
import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { useMedia } from "./context";
import { Button } from "@/components/ui/button";
import { Settings } from "lucide-react";

interface EditModeToggleProps {
  forceEditMode?: boolean;
}

const EditModeToggle: React.FC<EditModeToggleProps> = ({ forceEditMode = false }) => {
  const { language } = useLanguage();
  const { isEditMode, setIsEditMode } = useMedia();

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  if (forceEditMode) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-40">
      <Button 
        onClick={toggleEditMode}
        variant={isEditMode ? "default" : "outline"} 
        className={`rounded-full p-3 h-12 w-12 shadow-lg ${isEditMode ? "bg-palsustain-green" : ""}`}
      >
        <Settings className="h-5 w-5" />
      </Button>
    </div>
  );
};

export default EditModeToggle;
